import { IDeleteObraEstruturaOrganizacionalUseCase } from "../../../presentation/useCases/delete/delete_obra_estrutura_organizacional_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraEstruturaOrganizacionalUseCase
 */

export class DeleteObraEstruturaOrganizacionalUseCase implements IDeleteObraEstruturaOrganizacionalUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObraEstruturaOrganizacional(
    idEstruturaOrganizacional: number,
  ): Promise<void> {
    await this.repository.deleteObraEstruturaOrganizacional(idEstruturaOrganizacional);
  }
}
